import { VariantExchangeGuidanceSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/variant-exchange-guidance";
import * as z from "zod";

export const getVariantExchangeGuidance = {
  name: "getVariantExchangeGuidance" as const,
  input: z.object({}),
  output: z.object({
    variantExchangeGuidance: z.array(VariantExchangeGuidanceSchema),
  }),
};
